import { useAppSelector } from '../../app/hooks';
import { selectVersion } from '../../appSlice';

function TuzhiBackgroundVersion() {
  return useAppSelector(selectVersion);
}

export default TuzhiBackgroundVersion;
